import {AutogenLayoutGreenscreensControl} from "./autogen/AutogenLayoutGreenscreensControl";
import {ChangeEvent, DataSourceMode, DropdownItem, LayoutProps} from "@mcleod/components";
import {ModelRow} from "@mcleod/core";

interface controlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class GreenscreensControl extends AutogenLayoutGreenscreensControl{

    private _vendorId: string;

    constructor(props?: Partial<controlLayoutProps>) {
        super(props);
        this._vendorId = props?.vendorId;
    }

    async onLoad() {
        this.layoutRateIndexGeneral.textboxIntegrationId.visible = false;
        this.layoutRateIndexGeneral.textboxIntegrationId.required = false;

        this.mainDataSource.addAfterModeChangeListener(event => {
            if (event.newMode === DataSourceMode.ADD) {
                if (this.mainDataSource.activeRow == null) {
                    return;
                }
                this.activeRow.setValues(this.activeRow?.get("greenscreens_default_values"));
            }
        });
        this.sourceMarketrateExprt.addAfterModeChangeListener(event => {
            if (event.newMode === DataSourceMode.ADD) {
                if (this.sourceMarketrateExprt.activeRow == null) {
                    return;
                }
                this.sourceMarketrateExprt.activeRow.setValues(this.sourceMarketrateExprt.activeRow?.get("greenscreens_default_values"));
            }
        });
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            if(!this.validateRequiredFields(this.mainDataSource?.activeRow)){
                await this.mainDataSource.post();
                return false;
            }

            this.mainDataSource?.activeRow?.set("vendor", vendorId);
            this.sourceMarketrateExprt?.activeRow?.set("vendor", vendorId);
            if(!this.sourceMarketrateExprt?.activeRow?.get("account_number")){
                this.sourceMarketrateExprt?.activeRow?.set("account_number", "3");
            }
            await this.sourceMarketrateExprt.post();
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }
    switchUseMarketRateFuelSurchargeOnChange(event: ChangeEvent){
        this.textboxCustomerId.visible = event.newValue === false;
        this.textboxCustomerId.required = event.newValue === false;
    }

    switchEnableMarketRateExportOnChange(event:ChangeEvent){
        if (event.newValue) {
            this.setMarketRateExportVisibility(true);
        } else {
            this.setMarketRateExportVisibility(false);
        }
        this.marketRateExportSection.visible = event.newValue;
    }

    setMarketRateExportVisibility(isVisible) {
        this.marketRateExportSection.visible = isVisible;
        this.textboxLagDays.required = isVisible;
        this.textboxProcessDays.required = isVisible;
    }

    private validateRequiredFields(activeRow: ModelRow | undefined) {
        return activeRow?.get("user_name") && activeRow?.get("password") && activeRow?.get("webservice_address") && activeRow?.get("dashboard_url");
    }
}
